import router from './../router'
import QueryString from "./parser/QueryString";
import ValueChecker from "./ValueChecker";

export default {
    resolveUrl(name, row, query, state) {
        let resolvedRoute = router.resolve({path: name});
        let url = resolvedRoute.resolved.path;

        for (const key of Object.keys(resolvedRoute.resolved.params)) {
            if (resolvedRoute.resolved.path.includes(':' + key) && !ValueChecker.isUndefinedOrNull(query[key])) {
                url = url.replace(':' + key, row[query[key]]);
            }
        }

        let resolvedQuery = this.resolveQuery(query, row, state);

        if (Object.keys(resolvedQuery).length > 0) {
            url += '?' + QueryString.encode(resolvedQuery);
        }

        return url;
    },
    resolveRoute(url, row, query, state) {
        let resolvedQuery = this.resolveQuery(query, row, state);

        if (Object.keys(resolvedQuery).length > 0) {
            url += '?' + QueryString.encode(resolvedQuery);
        }

        let resolvedRoute = router.resolve({path: url});

        for (const key of Object.keys(resolvedRoute.resolved.params)) {
            if (!ValueChecker.isUndefinedOrNull(query[key])) {
                resolvedRoute.resolved.params[key] = row[query[key]];
            }
        }

        return resolvedRoute.resolved;
    },
    resolveQuery(query, row, state) {
        if (!query) {
            return;
        }

        let res = this.buildFromQuery(query, row);

        return Object.assign({}, state, res);
    },
    buildFromQuery(query, row) {
        let res = {};

        for (const [key, value] of Object.entries(query)) {
            if (ValueChecker.isObject(value) && value.directValue) {
                res[key] = value.directValue;
            } else if (!ValueChecker.isUndefinedOrNull(row[value])) {
                res[key] = row[value];
            }
        }

        return res;
    },
}


// WEBPACK FOOTER //
// ./src/services/UrlResolver.js